// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"236":"be7b1da99f587b2c9af2","288":"8ea541167a6d2a7cff81","918":"97d08b899c72b395acf2"}[chunkId] + ".js";
};